// English is the source of truth. `Dict` in ./types is derived from en.ts,
// so this file fails to compile if a key is missing or misspelled.
const de = {
  brand: { name: "SkillSynergy", first: "Skill", second: "Synergy" },

  nav: {
    courses: "Kurse",
    pricing: "Preise",
    about: "Über uns",
    contact: "Kontakt",
    bookCall: "Kostenloses Gespräch buchen",
    openMenu: "Menü öffnen",
    closeMenu: "Menü schließen",
    language: "Sprache",
    skipToContent: "Zum Inhalt springen",
  },

  cta: {
    exploreCourses: "Kurse entdecken",
    bookConsultation: "Kostenlose Beratung buchen",
    scheduleConsultation: "Kostenlose Beratung vereinbaren",
    viewCourse: "Kurs ansehen",
    viewAll: "Alle ansehen",
    comparePlans: "Alle Pakete vergleichen",
    getInTouch: "Kontakt aufnehmen",
    enrollNow: "Jetzt anmelden",
    seePricing: "Preise ansehen",
    purchaseNow: "Jetzt kaufen",
    contactUs: "Kontaktieren Sie uns",
    done: "Fertig",
  },

  footer: {
    tagline: "Live-Programmierkurse mit viel Praxis, für jedes Niveau.",
    coursesHeading: "Kurse",
    contactHeading: "Kontakt",
    contactBody:
      "Fragen zu einem Kurs? Wir antworten in der Regel innerhalb eines Werktags.",
    copyright: (year: number) =>
      `Copyright © ${year} SkillSynergy. Alle Rechte vorbehalten.`,
    terms: "AGB",
    privacy: "Datenschutzerklärung",
    imprint: "Impressum",
    cookieSettings: "Cookie-Einstellungen",
    socialLabel: (network: string) => `SkillSynergy auf ${network}`,
  },

  booking: {
    eyebrow: "Kostenlose Beratung",
    title: "Wir planen Ihren Weg in 30 Minuten",
    body: "Ohne Druck, ohne Kosten. Wir schätzen Ihr Niveau ein und empfehlen den passenden Kurs und die passende Ausrichtung.",
    benefits: [
      "Ein Lernplan, der auf Ihre Ziele zugeschnitten ist",
      "Begleitung durch einen erfahrenen Dozenten",
      "Antworten zu Preisen, Terminen und Format",
    ],
    formTitle: "Kostenloses Gespräch buchen",
    fullName: "Vollständiger Name",
    fullNamePlaceholder: "Erika Mustermann",
    email: "E-Mail",
    emailPlaceholder: "erika@email.com",
    courseOfInterest: "Kurs, der Sie interessiert",
    notSureYet: "Noch unsicher",
    preferredTrack: "Bevorzugte Ausrichtung",
    bestTime: "Beste Zeit für den Anruf",
    times: { morning: "Vormittag", afternoon: "Nachmittag", evening: "Abend" },
    submit: "Mein kostenloses Gespräch anfragen",
    submitting: "Wird gesendet…",
    disclaimer:
      "Wir geben Ihre Daten niemals weiter. Antwort innerhalb eines Werktags.",
    successTitle: "Anfrage erhalten",
    successBody:
      "Danke, wir melden uns innerhalb eines Werktags per E-Mail, um Ihre kostenlose Beratung zu bestätigen.",
    close: "Schließen",
    error:
      "Das hat nicht geklappt. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt.",
  },

  form: {
    required: "Dieses Feld ist erforderlich.",
    invalidEmail: "Geben Sie eine gültige E-Mail-Adresse ein.",
    consentLabel: "Ich habe die",
    consentLink: "Datenschutzerklärung",
    consentSuffix:
      "gelesen, stimme ihr zu und willige ein, dass meine Daten zur Beantwortung meiner Anfrage verwendet werden.",
    consentRequired:
      "Bitte akzeptieren Sie die Datenschutzerklärung, um fortzufahren.",
    rateLimited:
      "Sie haben das bereits mehrfach gesendet. Bitte warten Sie einen Moment, bevor Sie es erneut versuchen.",
  },

  consent: {
    title: "Wir achten Ihre Privatsphäre",
    body: "Wir verwenden Cookies, die für den Betrieb dieser Website unbedingt erforderlich sind. Mit Ihrer Erlaubnis möchten wir außerdem anonyme Fehlerberichte erfassen, damit wir Fehler schneller beheben können. Sie können Ihre Entscheidung jederzeit ändern.",
    acceptAll: "Alle akzeptieren",
    rejectAll: "Nicht notwendige ablehnen",
    save: "Auswahl speichern",
    customise: "Anpassen",
    privacyLink: "Datenschutzerklärung",
    imprintLink: "Impressum",
    categories: {
      necessary: {
        title: "Unbedingt erforderlich",
        body: "Notwendig, damit die Website funktioniert: Ihre Sprache, Ihre Cookie-Auswahl und grundlegende Sicherheit. Diese verlassen unsere Server nie.",
        always: "Immer aktiv",
      },
      analytics: {
        title: "Fehlerberichte",
        body: "Lädt Sentry, das Abstürze und Fehler meldet, damit wir sie beheben können. Es erhält Ihre IP-Adresse und Browser-Details.",
      },
    },
  },

  a11y: {
    previous: "Zurück",
    next: "Weiter",
    breadcrumb: "Brotkrümelnavigation",
    home: "Startseite",
    newTab: "wird in einem neuen Tab geöffnet",
  },
};

export default de;
